import React, { useCallback, useEffect, useRef } from 'react'
import FileIcon from 'components/FileIcon'
import Icon from 'components/Icon'
import { useDropzone } from 'react-dropzone'
import messages from './messages'
import { FormattedMessage, useIntl } from 'react-intl'
import { Button } from '@arnsbogroup/react-voicearchive'

const Files = ({ attribute, state, onChange }) => {
  const { key, name, options, disabled } = attribute
  const parsed = useRef(false)
  const { formatMessage } = useIntl()

  const files = state || []

  const onDrop = (nextFiles) => {
    if (disabled) {
      return
    }

    onChange([...files, ...Array.from(nextFiles)])
  }

  const onDelete = (index) => {
    if (typeof files[index].src === 'undefined') {
      return onChange(files.filter((_, i) => i !== index))
    }

    onChange(Object.assign([], files, {
      [index]: { ...state[index], ACTION: 'DELETE' }
    }))
  }

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    maxSize: 50 * 1024 * 1024, //MB to Bytes
    onDropRejected: (rejectedFiles) => {
      const fileRejected = rejectedFiles[0]
      if (fileRejected) {
        toastr.error(formatMessage(messages.dropZoneError, { fileName: fileRejected.file.name }))
      }
    },
  })

  return (
    <fieldset className="space-y-1 cursor-pointer" {...getRootProps()}>
      <p className="text-xs font-medium text-gray-600 uppercase tracking-wider">
        { name }
      </p>

      <div className={`w-full mt-1 flex justify-center p-3 border-2 border-gray-300 border-dashed ${disabled ? 'bg-gray-50 cursor-not-allowed' : ''}`}>
        <div className="space-y-1 text-center w-full">
          { files.map(({ src, name, ACTION }, i) => (
            <div
              className="px-4 py-2 w-full border border-gray-300 shadow-sm rounded-sm flex justify-between items-center cursor-pointer hover:text-gray-500" key={`file-${i}`}
              onClick={(event) => {
                event.stopPropagation()
                window.open(
                  src ? src : URL.createObjectURL(files[i]),
                  name,
                  'menubar=no,location=no,resizable=yes,scrollbars=yes,status=no,width=400,height=500'
                )
              }}
            >
              <div>
                <FileIcon filename={name} className="mr-2" />
                <span className="text-xs uppercase font-medium">{ name }</span>
                { ACTION === 'DELETE' &&
                  <span className="inline-block px-2 py-0.5 text-xs font-medium bg-negative text-white rounded-sm ml-2"><FormattedMessage{...messages.deleted}/></span>
                }
              </div>

              <div>
                { !disabled && !ACTION &&
                  <Button
                    variant="inline"
                    size="sm"
                    state="negative"
                    onClick={(event) => {
                      event.preventDefault()
                      event.stopPropagation()
                      onDelete(i)
                    }}
                  >
                    Remove
                  </Button>
                }

                { src &&
                  <a className="cursor-pointer text-primary hover:text-primary-darker" href={src} target="_blank">
                    <Icon icon="arrow-down" />
                  </a>
                }
              </div>
            </div>
          )) }
          <div className="my-2 text-center text-gray-600 py-4">
            <p className="space-x-1 text-sm">
              <label className="relative cursor-pointer rounded-sm font-medium text-primary hover:text-primary-darker focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary">
                <span><FormattedMessage{...messages.upload}/></span>
              </label>
              <input
                id="file-upload"
                disabled={disabled}
                name="file-upload"
                type="file"
                className="sr-only"
                onClick={(event) => event.stopPropagation()}
                {...getInputProps()}
              />
              <span><FormattedMessage{...messages.dragDrop}/></span>
            </p>
            <p className="text-xs text-gray-500">
              <FormattedMessage{...messages.audioFormats}/>
            </p>
          </div>
        </div>
      </div>
    </fieldset>
  )
}

export default Files
